var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 141,
    viewBox: "0 0 140 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 140,
    height: 140,
    rx: 4,
    fill: "#F2F4F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 63.8333C63.6819 63.8333 66.6666 60.8486 66.6666 57.1667C66.6666 53.4848 63.6819 50.5 60 50.5C56.3181 50.5 53.3333 53.4848 53.3333 57.1667C53.3333 60.8486 56.3181 63.8333 60 63.8333Z",
    stroke: "#3F3939",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3334 37.1665H60C43.3334 37.1665 36.6667 43.8332 36.6667 60.4998V80.4998C36.6667 97.1665 43.3334 103.833 60 103.833H80C96.6667 103.833 103.333 97.1665 103.333 80.4998V63.8332",
    stroke: "#3F3939",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5 47.1665H100.833",
    stroke: "#3F3939",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6667 56.3333V38",
    stroke: "#3F3939",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9 93.6667L55.3334 82.6334C57.9667 80.8667 61.7667 81.0667 64.1334 83.1L65.2334 84.0667C67.8334 86.3 72.0334 86.3 74.6334 84.0667L88.5 72.1667C91.1 69.9334 95.3 69.9334 97.9 72.1667L103.333 76.8334",
    stroke: "#3F3939",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadImage);
export default __webpack_public_path__ + "static/media/upload-image.91fb83b1dabf8309a2e603d969bfb8a2.svg";
export { ForwardRef as ReactComponent };